module.exports = __webpack_public_path__ + "static/media/203-sahrawi-arab-democratic-republic.d1411284.svg";